import { Button } from '@neo/primitives/button'
import { ReactComponent as VibeMascot } from '@shared/assets/icons/vibe-mascot.svg'
import { useFlowStore } from '../../store'
import { VIBE_EVAL_COMMAND_MESSAGE } from '../vibe-agent/constants'
import { useVibeRunActive } from '../vibe-agent/use-vibe-run-active'
import { useVibeSend } from '../vibe-agent/use-vibe-send'

export const TestWithVibeButton = () => {
  const isVibeGenerating = useVibeRunActive()
  const setShowVibeSidebar = useFlowStore((state) => state.setShowVibeSidebar)
  const sendVibeMessage = useVibeSend()

  const handleClick = () => {
    // Ensure sidebar is open
    setShowVibeSidebar(true)
    // Send the eval command message through whichever pipeline the flag selects
    sendVibeMessage(VIBE_EVAL_COMMAND_MESSAGE)
  }

  const disabledReason = isVibeGenerating
    ? 'Please wait for Vibe Agent to finish its current response'
    : undefined

  return (
    <Button
      variant="ghost"
      size="xs"
      typography="action"
      type="button"
      onClick={handleClick}
      disabled={!!disabledReason}
      disabledReason={disabledReason}
      data-testid="button-test-with-vibe"
    >
      <VibeMascot className="pointer-events-none w-5 h-5 pb-0.5 mr-2" />
      Test with Vibe Agent
    </Button>
  )
}
